import React from "react";
import "./Style.css";

type Props = {
  title: string;
  description?: string;
  minHeightRem?: number;
};

const StatusMessage = ({ title, description, minHeightRem = 8 }: Props) => {
  return (
    <div
      className="status-message"
      style={{ minHeight: `${minHeightRem}rem` }}
    >
      <div className="status-message-content">
        <div className="status-message-title">{title}</div>
        {description ? (
          <div className="status-message-description">{description}</div>
        ) : null}
      </div>
    </div>
  );
};

export default StatusMessage;
